import { render, staticRenderFns } from "./HuyenXaPhuong.vue?vue&type=template&id=5f00e62a&scoped=true&"
import script from "./HuyenXaPhuong.vue?vue&type=script&lang=js&"
export * from "./HuyenXaPhuong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00e62a",
  null
  
)

export default component.exports